import { apiClient } from "./ApiClient";

/** ---------------------------
 *  EC2 STATUS
 * --------------------------- */
export const checkEC2StatusAPI = async (
  organization,
  username,
  includeScript = false,
  instanceId,
  region = "us-east-1"
) => {
  const payload = {
    action: "getStatus",
    region,
    organization,
    username,
    includeScript,
  };

  if (instanceId) payload.instanceId = instanceId;

  const response = await apiClient.post("modeltesting", payload);
  return response.data;
};


/** ---------------------------
 *  EC2 START
 * --------------------------- */
export const startEC2API = async (
  organization,
  username,
  instanceId,
  objectName,
  region = "us-east-1"
) => {
  const payload = {
    action: "startEC2",
    region,
    organization,
    username,
    objectName,
  };

  if (instanceId) {
    payload.instanceId = instanceId;
  }

  const response = await apiClient.post("modeltesting", payload);
  return response.data;
};


/** ---------------------------
 *  EC2 STOP
 * --------------------------- */
export const stopEC2API = async (
  organization,
  username,
  instanceId,
  region = "us-east-1"
) => {
  const payload = {
    action: "stopEC2",
    region,
    organization,
    username,
  };

  if (instanceId) {
    payload.instanceId = instanceId;
  }

  const response = await apiClient.post("modeltesting", payload);
  return response.data;
};


/** ---------------------------
 *  DOWNLOAD FILES INTO EC2
 * --------------------------- */
export const triggerDownloadForInferenceToEC2 = async (
  instanceId,
  organization,
  datePrefix,
  fileList
) => {
  const payload = {
    action: "downloadForInference",
    organization,
    datePrefix,
    fileList,
  };
  if (instanceId) payload.instanceId = instanceId;

  const resp = await apiClient.post("modeltesting", payload);
  return resp.data;
};


/** ---------------------------
 *  FETCH FILES FROM S3
 * --------------------------- */
export const fetchFilesAPI = async (organization, startDate, endDate) => {
  const payload = {
    action: "fetchFiles",
    organization,
    startDate,
    endDate,
  };
  const resp = await apiClient.post("modeltesting", payload);
  return { files: resp.data.message };
};


/** ---------------------------
 *  GET PRESIGNED URL
 * --------------------------- */
export const getPresignedUrlAPI = async (organization, fileUrl) => {
  const payload = {
    action: "getPresignedUrl",
    organization,
    fileUrl,
  };
  const resp = await apiClient.post("modeltesting", payload);
  return resp.data;
};


/** ---------------------------
 *  S3 WATCHER FOR INFERENCE OUTPUT
 * --------------------------- */
export const triggerInferenceFileWatcherAPI = async (
  organization,
  s3Prefix,
  expectedFiles
) => {
  const payload = {
    action: "startInferenceFileWatcher",
    organization,
    s3Prefix,
    fileList: expectedFiles,
  };
  const resp = await apiClient.post("modeltesting", payload);
  return resp.data;
};


/** ---------------------------
 *  SCRIPT START
 * --------------------------- */
// ModelTestingService.js
export const startDetectionScriptAPI = async (
  organization,
  username,
  instanceId,
  objectName,          // use case / model name
  region = "us-east-1"
) => {
  const payload = {
    action: "startDetectionScript",
    region,
    organization,
    username,
    objectName,
  };

  if (instanceId) {
    payload.instanceId = instanceId;
  }

  const response = await apiClient.post("modeltesting", payload);
  return response.data;
};


/** ---------------------------
 *  SCRIPT STOP
 * --------------------------- */
/** ---------------------------
 *  SCRIPT STOP
 * --------------------------- */
export const stopDetectionScriptAPI = async (
  organization,
  username,
  instanceId,
  objectName,
  region = "us-east-1"
) => {
  const payload = {
    action: "stopDetectionScript",
    region,
    organization,
    username,
    objectName,
  };

  if (instanceId) {
    payload.instanceId = instanceId; // backend ignores this today but it's safe to send
  }

  const resp = await apiClient.post("modeltesting", payload);
  return resp.data;
};


/** ---------------------------
 *  SCRIPT STATUS (OPTIONAL)
 * --------------------------- */
export const getDetectionScriptStatusAPI = async (instanceId, region = "us-east-1") => {
  const payload = {
    action: "getDetectionScriptStatus",
    region,
  };
  if (instanceId) payload.instanceId = instanceId;

  const resp = await apiClient.post("modeltesting", payload);
  return resp.data;
};


/** ---------------------------
 *  LIST TRAINED MODELS
 * --------------------------- */
export const listModelsAPI = async (organization) => {
  const payload = { action: "listAvailableModels", organization };
  const resp = await apiClient.post("modeltesting", payload);
  return { files: resp.data.message };
};


/** ---------------------------
 *  STREAMING ORCHESTRATOR
 * --------------------------- */
export const orchestrateKVSStackAPI = (
  instanceId,
  op,              // "start" | "stop"
  streamName,
  organization,
  username,
  region = "us-east-1"
) =>
  apiClient
    .post("/modeltesting", {
      action: "orchestrateKvsStack",
      instanceId,
      op,
      organization,
      username,     // <-- IMPORTANT
      region,
      streamName,
    })
    .then((res) => res.data);


/** ---------------------------
 *  LIST PROCESSED FRAME PAIRS (ARCHIVE)
 * --------------------------- */
export const listReadyPairsAPI = async (
  organization,
  date,
  pageSize = 200,
  cursor
) => {
  const payload = {
    action: "listReadyPairs",
    organization,
    date,
    pageSize,
    cursor,
  };
  const resp = await apiClient.post("modeltesting", payload);
  return resp.data?.message;
};


/** ---------------------------
 *  TUTORIAL ZIP DOWNLOAD URL
 * --------------------------- */
export const getTutorialZipDownloadUrlAPI = async (
  organization,
  username,
  region = "us-east-1"
) => {
  const payload = {
    action: "getTutorialZipDownloadUrl",
    organization,
    username,
    region,
  };

  const resp = await apiClient.post("modeltesting", payload);
  return resp.data; // expects { url, filename, key }
};

